// This file contains all code that interacts with the API server
// It depends on jQuery or compatible system being available through "$"
import Promise from 'bluebird';
import jwt from 'jsonwebtoken';
import $ from "jquery";

// Some global config :
var server_environment = {
  development:"http://localhost:5000",
  test:"https://deconx-test.herokuapp.com",
  production:"https://data-dx.deconx.com"
}
var APP_METADATA = "https://rui.deconx.com/app_metadata";

let _server = server_environment[process.env.NODE_ENV];
console.log(process.env.NODE_ENV);
console.log("Using server at "+_server);
//let _server = "http://192.168.11.22:5000";
let _token = null; // Needs to be set by user before using API
let _expiredCallback = null;
// Any request we send, we attach the userToken as a Authorization header
let oustandingRequests = 0;
$.ajaxSetup({
  'beforeSend': function(xhr) {
    //console.log("beforeSend",xhr);
    if (_token) {
      xhr.setRequestHeader('Authorization','Bearer ' + _token);
    };
    oustandingRequests = oustandingRequests + 1;
    // console.log("Outstanding requests : "+oustandingRequests);
  },
  'complete'(xhr,status) {
    // console.log("complete",xhr,status);
    if(xhr.status==401 && _expiredCallback!=null) {
      console.log("Token may be expired, calling handling function for cleanup");
      _expiredCallback();
    }
    oustandingRequests = oustandingRequests - 1;
    // console.log("Outstanding requests : "+oustandingRequests);
  }
});

var ServerAPI =  {
  checkTokenExpired : function (token) {
    var payload = jwt.decode(token);
    var expDate = new Date(payload.exp*1000);
    var now = new Date();
    return expDate < now;
  },
  // The token contains the id_customer\id_user Identity:
  getUserProfileFromToken : function (token) {
    var payload = jwt.decode(token);
    var id_user = null;
    var id_customer = null;
    if(payload.app_metadata) {
      id_user = payload.app_metadata.id_user;
      id_customer = payload.app_metadata.id_customer;
    } else if(payload[APP_METADATA]) {
      id_user = payload[APP_METADATA].id_user;
      id_customer = payload[APP_METADATA].id_customer;
    }
    // Null means that we do not have a log in with a connected user profile.
    return {id_user,
            id_customer,
            email:payload.email,
            email_verified:payload.email_verified,
            impersonator:payload.impersonator
          };
  },
  setExpiredCallback : function (cb) {
    _expiredCallback=cb;
  },
  setToken(token) {
    _token = token;
    if(_token==null) return;
    var payload = jwt.decode(token);
    var expDate = new Date(payload.exp*1000);
    let msToExpire = expDate-Date.now();
    // When the token expires, we clear it and run the callback for token expiration:
    console.log("Login will expire in " + (msToExpire/1000).toFixed(0) + " seconds");
    setTimeout(()=>{
      _token = "Expired token, very invalid.";
      if(!!_expiredCallback) _expiredCallback();
    },msToExpire);
  },
  // Request that the server clears its permission cache, used at logout to
  // allow logging out and back in to fix permission-fixes.
  clearPermissionCache() {
    return Promise.resolve(
      $.getJSON(`${_server}/admin/clear_permission_cache`)
    );
  },
  // Gets list of all machines for a given customer
  getImpersonateToken(id_customer,id_user) {
    return Promise.resolve(
      $.getJSON(`${_server}/admin/customer/${encodeURI(id_customer)}/user/${encodeURI(id_user)}/impersonate`)
    );
  },
  // Gets list of all machines for a given customer
  getCustomerMachineList(id_customer) {
    return Promise.resolve(
      $.getJSON(`${_server}/customer/${encodeURI(id_customer)}/machines`)
    );
  },
  // Gets list of available disinfection job types for customer
  getCustomerJobTypes(id_customer) {
    return Promise.resolve(
      $.getJSON(`${_server}/customer/${encodeURI(id_customer)}/job_types`)
    );
  },
  // Gets list of grantable roles for current logged in user:
  getGrantableRoles(id_customer,id_user) {
    return Promise.resolve(
      $.getJSON(`${_server}/customer/${encodeURI(id_customer)}/user/${encodeURI(id_user)}/grant_roles`)
    );
  },
  // Gets list of recent jobs for a given customer
  getCustomerRecentJobList(id_customer) {
    return Promise.resolve(
      $.getJSON(`${_server}/customer/${encodeURI(id_customer)}/recent_jobs`)
    );
  },
  // Gets list of recent jobs for a given machine
  getMachineRecentJobList(machine_id) {
    return Promise.resolve(
      $.getJSON(`${_server}/machine/${encodeURI(machine_id)}/recent_jobs`)
    );
  },
  // Fetch details for a set of (running) jobs
  // jobList is an array of objects with primary key id(s) for job(s):
  getJobDetails(id_customer,machineIdList,timeStampLastJobUpdate) {
    if(!machineIdList || machineIdList.length==0) {
      console.log("Calling getJobDetails without machinelist.")
      return Promise.resolve([]);
    }
    var request_param = { machineIdList,timeStampLastJobUpdate }
    return Promise.resolve($.ajax({
          url: `${_server}/customer/${encodeURI(id_customer)}/job_updates`,
          type: 'POST',
          contentType: 'application/json',
          data: JSON.stringify(request_param)}
      ));
  },
  // Gets list of recent jobs for a given user
  getUserRecentJobList(id_customer,id_user) {
    return Promise.resolve(
      $.getJSON(`${_server}/customer/${encodeURI(id_customer)}/user/${encodeURI(id_user)}/recent_jobs`)
    );
  },
  // Gets list of recent jobs for a user's location domain
  getJobsInUserDomain(id_customer,id_user, fetchBefore) {
    if(fetchBefore){
      return Promise.resolve(
        $.getJSON(`${_server}/customer/${encodeURI(id_customer)}/user/${encodeURI(id_user)}/area_jobs?lastFetchDate=${encodeURI(fetchBefore)}`)
      )
    }
    return Promise.resolve(
      $.getJSON(`${_server}/customer/${encodeURI(id_customer)}/user/${encodeURI(id_user)}/area_jobs`)
    );
  },
  // Gets list of users for a given customer
  fetchUsersForCustomer(id_customer) {
    return Promise.resolve(
      $.getJSON(`${_server}/customer/${encodeURI(id_customer)}/users`)
    );
  },
  // Get audit log
  fetchAuditLog(params) {
    return Promise.resolve(
      $.getJSON(`${_server}/audit-logs`, params || null)
    );
  },
  // Gets list of users for a given user's domain
  fetchUsersFromUserLocationDomain(id_customer,id_user) {
    return Promise.resolve(
      $.getJSON(`${_server}/customer/${encodeURI(id_customer)}/user/${encodeURI(id_user)}/area_users`)
    );
  },
  // Gets info/profile for given user
  getUserInfo(id_customer,id_user) {
    return Promise.resolve(
      $.getJSON(`${_server}/customer/${encodeURI(id_customer)}/user/${encodeURI(id_user)}/info`)
    );
  },
  // Gets list of relevant locations for user
  getUserLocations(id_customer,id_user) {
    return Promise.resolve(
      $.getJSON(`${_server}/customer/${encodeURI(id_customer)}/user/${encodeURI(id_user)}/locations`)
    );
  },
  // Gets list of relevant beacons for user
  getBeaconsForCustomer(id_customer) {
    return Promise.resolve(
      $.getJSON(`${_server}/customer/${encodeURI(id_customer)}/beacons`)
    );
  },
  // Gets list of available machines for location
  getLocationAvailableMachines(id_location) {
    return Promise.resolve(
      $.getJSON(`${_server}/location/${encodeURI(id_location)}/machines`)
    );
  },
  // Gets list of relevant machines for given user based on users home_location
  getUserMachines(id_customer,id_user) {
    return Promise.resolve(
      $.getJSON(`${_server}/customer/${encodeURI(id_customer)}/user/${encodeURI(id_user)}/machines`)
    );
  },
  // Gets list of user permissions
  getUserPermissions(id_customer,id_user) {
    return Promise.resolve(
      $.getJSON(`${_server}/customer/${encodeURI(id_customer)}/user/${encodeURI(id_user)}/permissions`)
    );
  },
  // Gets list of user roles
  getUserRoles(id_customer,id_user) {
    return Promise.resolve(
      $.getJSON(`${_server}/customer/${encodeURI(id_customer)}/user/${encodeURI(id_user)}/roles`)
    );
  },
  // Gets list of customers belonging to a distributor
  getCustomerListForDistributor(id_customer, machine_name) {
    if (typeof machine_name !== 'undefined' && machine_name !== '') {
        return Promise.resolve(
            $.getJSON(`${_server}/distributor/${encodeURI(id_customer)}/customers?machine_name=${encodeURI(machine_name)}`)
        );
    } else {
        return Promise.resolve(
            $.getJSON(`${_server}/distributor/${encodeURI(id_customer)}/customers`)
        );
    }
  },
  // Gets the next available customer Id for Distributor
  getNextCustomerIdForDistributor(id_customer) {
      return Promise.resolve(
          $.getJSON(`${_server}/distributor/${encodeURI(id_customer)}/next-customer-id`)
      );
  },
  getMachineDetails(id_customer, id_machine) {
    return Promise.resolve(
      $.getJSON(`${_server}/machine/${encodeURI(id_customer)}/${encodeURI(id_machine)}/details`)
    );
  },
  getMachineHistory(id_machine){
    return Promise.resolve(
      $.getJSON(`${_server}/machine/${encodeURI(id_machine)}/history`)
    );
  },
  setMachineAction(machineId, startTime, action) {
    // Passing new record as JSON in request body
    return Promise.resolve($.ajax({
      url: `${_server}/machine/${encodeURI(machineId)}/action/${action}`,
          type: 'POST',
          contentType: 'application/json',
          data: JSON.stringify({
            machineId,
            startTime
          })
        }
      ));
  },
  // The start_time is given in milliseconds since 1970 in a hope to avoid
  // time-zone issues etc. when parsing.
  // The method fetches all data for the job (metadata and measurements)
  getJobsDetails(id_machine,start_time) {
    return Promise.resolve(
      $.getJSON(`${_server}/machine/${encodeURI(id_machine)}/job/${encodeURI(start_time)}`)
    );
  },
  // insert a new machine into the machine table
  insertNewUser(user) {
    // Passing new record as JSON in request body
    return Promise.resolve($.ajax({
      url: `${_server}/customer/${encodeURI(user.id_customer)}/user/new`,
          type: 'POST',
          contentType: 'application/json',
          data: JSON.stringify(user)}
      ));
  },
  // insert a new machine into the machine table
  insertNewMachine(machine) {
    // Passing new record as JSON in request body
    return Promise.resolve($.ajax({
          url: `${_server}/machine/newMachine`,
          type: 'POST',
          contentType: 'application/json',
          data: JSON.stringify(machine)}
      ));
  },
  // insert a new location
  insertNewLocation(id_customer,location) {
    // Passing new record as JSON in request body
    // This slimmed down copy is to avoid issues with
    // paren/children references and circular JSON encoding issues.
    var newLocationData = {
      id_parent :location.id_parent,
      name      :location.name,
      volume_m3 :location.volume_m3,
      height    :location.height,
      length    :location.length,
      width    :location.width,
      id_type   :location.id_type,
      default_job_type :location.default_job_type,
      new_beacon_id: location.new_beacon_id
    };
    return Promise.resolve($.ajax({
          url: `${_server}/customer/${encodeURI(id_customer)}/location/new`,
          type: 'POST',
          contentType: 'application/json',
          data: JSON.stringify(newLocationData)}
      ));
  },
  updateOrDeleteLocation(id_customer,location) {
    // Passing the updated record as JSON in request body
    // To avoid circular references (which kills the JSON-coding)
    location.parent=null;
    location.children=null;
    return Promise.resolve($.ajax({
          url: `${_server}/customer/${encodeURI(id_customer)}/location_update`,
          type: 'POST',
          contentType: 'application/json',
          data: JSON.stringify(location)}
      ));
  },
  removeBeaconFromLocation(customer_id, beacon_id) {
    return Promise.resolve($.ajax({
      url: `${_server}/customer/${encodeURI(customer_id)}/beacons/remove`,
      type: 'POST',
      contentType: 'application/json',
      data: JSON.stringify({ "id":beacon_id})
    }))
  },
  userExists(id_customer,id_user) {
    return Promise.resolve($.ajax({
          url: `${_server}/customer/${encodeURI(id_customer)}/user/${encodeURI(id_user)}/exists`,
          type: 'GET',
          contentType: 'application/json'
        }));
  },
  updateOrDeleteUser(id_customer,user) {
    return Promise.resolve($.ajax({
          url: `${_server}/customer/${encodeURI(id_customer)}/user_update`,
          type: 'POST',
          contentType: 'application/json',
          data: JSON.stringify(user)}
      ));
  },
  sendStackToServer(stackLines) {
    return Promise.resolve($.ajax({
          url: `${_server}/stackLines`,
          type: 'POST',
          contentType: 'application/json',
          data: JSON.stringify(stackLines)}
      ));
  },
  findRecentDeletions(id_customer, lastDays) {
    return Promise.resolve($.ajax({
      url: `${_server}/customer/${encodeURI(id_customer)}/recent_deletes/${encodeURI(lastDays)}`,
      type: 'GET',
      contentType: 'application/json'
    }));
  },
  restoreUser(id_customer, id_user) {
    return Promise.resolve($.ajax({
      url: `${_server}/customer/${encodeURI(id_customer)}/user/${encodeURI(id_user)}/restore_user`,
      type: 'GET',
      contentType: 'application/json'
    }));
  },
  resendVerificationEmailForUser(login_email) {
    return Promise.resolve($.ajax({
      url: `${_server}/user_utils/${encodeURI(login_email)}/resend_verification_email`,
      type: 'GET',
      contentType: 'application/json'
    }));
  },
  restoreLocations(id_customer, deletion_timestamp) {
    return Promise.resolve($.ajax({
      url: `${_server}/customer/${encodeURI(id_customer)}/ts/${+deletion_timestamp}/restore_locations`,
      type: 'GET',
      contentType: 'application/json'
    }));
  },
  restoreLocationsById(id_customer, id_location) {
    return Promise.resolve($.ajax({
      url: `${_server}/customer/${encodeURI(id_customer)}/location/${encodeURI(id_location)}/restore_locations`,
      type: 'GET',
      contentType: 'application/json'
    }));
  },
  findLocationTypes() {
    return Promise.resolve($.ajax({
      url: `${_server}/types/location_types`,
      type: 'GET',
      contentType: 'application/json'
    }));
  },
  sendVerifyCode(id_customer, id_user, phone) {
    return Promise.resolve($.ajax({
      url: `${_server}/customer/${encodeURI(id_customer)}/user/${encodeURI(id_user)}/phone/${encodeURI(phone)}/send_verify_code`,
      type: 'GET',
      contentType: 'application/json'
    }));
  },
  checkVerifyCode(id_customer, id_user, code) {
    return Promise.resolve($.ajax({
      url: `${_server}/customer/${encodeURI(id_customer)}/user/${encodeURI(id_user)}/code/${encodeURI(code)}/check_phone_code`,
      type: 'GET',
      contentType: 'application/json'
    }));
  },
  queueEmailReport(id_machine, end_time) {
    console.log(id_machine, end_time);
    // We pass the timestamp as a number, to avoid parsing text-formatted
    // timestamps on the other side.
    return Promise.resolve($.ajax({
      url: `${_server}/emailreport/machine/${encodeURI(id_machine)}/job/${+end_time}`,
      type: 'GET',
      contentType: 'application/json'
    }));
  },
  checkIfEmailExist(email) {
    return Promise.resolve($.ajax({
      url: `${_server}/check_email/${encodeURI(email)}`,
      type: 'GET',
      contentType: 'application/json'
    }));
  },
  updateMachineConfig(id_machine, propValues) {
    return Promise.resolve($.ajax({
      url: `${_server}/machine/${encodeURI(id_machine)}/store_configuration`,
      type: 'POST',
      contentType: 'application/json',
      data: JSON.stringify(propValues)
    }))
  },
  resetMachineConfig(id_machine) {
    return Promise.resolve($.ajax({
      url: `${_server}/machine/${encodeURI(id_machine)}/reset_configuration`,
      type: 'PUT',
      contentType: 'application/json'
    }))
  },
  resetRunningTime(id_machine, component_csv) {
    return Promise.resolve($.ajax({
      url: `${_server}/machine/${encodeURI(id_machine)}/reset_running_time?component_csv=${encodeURI(component_csv)}`,
      type: 'PUT',
      contentType: 'application/json'
    }));
  },
  sendTestSMS(id_customer,id_user) {
    return Promise.resolve($.ajax({
      url: `${_server}/customer/${encodeURI(id_customer)}/user/${encodeURI(id_user)}/sendTestSMS`,
      type: 'GET',
      contentType: 'application/json'
    }));
  },
  getCustomerDetails(id_customer)  {
    return Promise.resolve($.ajax({
      url: `${_server}/customer/${encodeURI(id_customer)}/details`,
      type: 'GET',
      contentType: 'application/json'
    }));
  },
  getCustomerSegments()  {
    return Promise.resolve($.ajax({
      url: `${_server}/customer_segments`,
      type: 'GET',
      contentType: 'application/json'
    }));
  },
  getJobTypes()  {
    return Promise.resolve($.ajax({
      url: `${_server}/customer/job_types`,
      type: 'GET',
      contentType: 'application/json'
    }));
  },
  getSupportedCountries()  {
    return Promise.resolve($.ajax({
      url: `${_server}/supported_countries`,
      type: 'GET',
      contentType: 'application/json'
    }));
  },
  updateCustomerDetails(customer) {
    return Promise.resolve($.ajax({
      url: `${_server}/customer/${encodeURI(customer.id)}/update`,
      type: 'POST',
      contentType: 'application/json',
      data: JSON.stringify(customer)
    }));
  },
  deleteCustomerDetails(customer) {
    return Promise.resolve($.ajax({
      url: `${_server}/customer/${encodeURI(customer.id)}/delete`,
      type: 'POST',
      contentType: 'application/json',
      data: JSON.stringify(customer)
    }));
  },  
  insertNewCustomer(customer, adminUser) {
    return Promise.resolve($.ajax({
      url: `${_server}/customer/${encodeURI(customer.id)}/new`,
      type: 'POST',
      contentType: 'application/json',
      data: JSON.stringify({customer,adminUser})
    }));
  },
  checkIfCustomerIdExist(id_customer) {
    return Promise.resolve($.ajax({
      url: `${_server}/customer/${encodeURI(id_customer)}/exist`,
      type: 'GET',
      contentType: 'application/json'
    }));
  },
  machineSearch(searchParams) {
    return Promise.resolve($.ajax({
      url: `${_server}/machine/search`,
      type: 'POST',
      contentType: 'application/json',
      data: JSON.stringify(searchParams)
    }));
  },
  machineName(id_customer, id_machine) {
    return Promise.resolve($.ajax({
      url: `${_server}/customer/${encodeURI(id_customer)}/machine/${encodeURI(id_machine)}/name`,
      type: 'GET',
      contentType: 'application/json'
    }));
  },
  assignMachine(assignmentRecord) {
    return Promise.resolve($.ajax({
      url: `${_server}/machine/assign`,
      type: 'POST',
      contentType: 'application/json',
      data: JSON.stringify(assignmentRecord)
    }));
  },
  insertContract(contract) {
    return Promise.resolve($.ajax({
      url: `${_server}/contract/new`,
      type: 'POST',
      contentType: 'application/json',
      data: JSON.stringify(contract)
    }));
  },
  getContract(id_customer, id_contract) {
    return Promise.resolve($.ajax({
      url: `${_server}/contract/${encodeURI(id_customer)}/${encodeURI(id_contract)}`,
      type: 'GET',
      contentType: 'application/json'
    }));
  },
  updateContract(contract) {
    return Promise.resolve($.ajax({
      url: `${_server}/contract/update`,
      type: 'POST',
      contentType: 'application/json',
      data: JSON.stringify(contract)
    }));
  },
  fetchCustomerMachineContracts(id_customer, id_machine) {
    return Promise.resolve($.ajax({
      url: `${_server}/customer/${encodeURI(id_customer)}/machine/${encodeURI(id_machine)}/contracts`,
      type: 'GET',
      contentType: 'application/json'
    }));
  },
  fetchMessageDefinitions(language_code) {
    return Promise.resolve($.ajax({
      url: `${_server}/ui_messages/${encodeURI(language_code)}`,
      type: 'GET',
      contentType: 'application/json'
    }));
  },
  getSupportedLanguages() {
    return Promise.resolve($.ajax({
      url: `${_server}/supported_languages`,
      type: 'GET',
      contentType: 'application/json'
    }));
  },
  getSimCardInfo(iccid) {
    return Promise.resolve($.ajax({
      url: `${_server}/SIM/${encodeURI(iccid)}/info`,
      type: 'GET',
      contentType: 'application/json'
    }));
  },
  getSIMSubscription() {
    return Promise.resolve($.ajax({
      url: `${_server}/SIM/subscriptionInformation`,
      type: 'GET',
      contentType: 'application/json'
    }));
  },
  getSimCardDetails(phoneNumber) {
    return Promise.resolve($.ajax({
      url: `${_server}/SIM/${encodeURI(phoneNumber)}/details`,
      type: 'GET',
      contentType: 'application/json'
    }));
  },
  registerSimCards(form) {
    return Promise.resolve($.ajax({
      url: `${_server}/SIM/add`,
      type: 'POST',
      contentType: 'application/json',
      data: JSON.stringify(form)
    }));
  },
  updateSimCard(sim) {
    return Promise.resolve($.ajax({
      url: `${_server}/SIM/update`,
      type: 'POST',
      contentType: 'application/json',
      data: JSON.stringify(sim)
    }));
  },
  activateSimCard(id_machine,iccid) {
    return Promise.resolve($.ajax({
      url: `${_server}/SIM/${encodeURI(iccid)}/${encodeURI(id_machine)}/activate`,
      type: 'GET',
      contentType: 'application/json'
    }));
  },
  deactivateSimCard(id_machine,iccid) {
    return Promise.resolve($.ajax({
      url: `${_server}/SIM/${encodeURI(iccid)}/${encodeURI(id_machine)}/deactivate`,
      type: 'GET',
      contentType: 'application/json'
    }));
  },

};

window.debugServerAPI=ServerAPI;

export default ServerAPI;



/** WEBPACK FOOTER **
 ** ./src/ServerAPI.js
 **/